import React, {useEffect} from 'react';
import Breadcrumb from '../../breadcrumb';

interface Props {
  sidebar: React.ReactNode;
  content: React.ReactNode;
}

const SidebarContainer: React.FC<Props> = ({ sidebar, content }) => {
  useEffect(() => {
    function adjustScroll() {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 86;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      }
    }

    // Run when the page is loaded
    adjustScroll()
    // Run when hash changes (hash changes dont cause force-reload)
    window.addEventListener('hashchange', adjustScroll)
    // Cleanup
    return () =>
      window.removeEventListener('hashchange', adjustScroll)
  }, [])

  return (
    <section>
      <div className="sidebar-layout">
        <div className="sidebar">
          <Breadcrumb/>
          {sidebar}
        </div>
        <div className="content">{content}</div>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        :global(html) {
          scroll-behavior: smooth;
        }

        .sidebar-layout {
          display: flex;
          height: 100%;
        }

        .sidebar {
          background-color: #eee;
          flex: 1 1 auto;
          flex-basis: 33%;
        }

        .content {
          background-color: #fff;
          flex: 2 1 auto;
          flex-basis: 66%;
        }

        @media screen and (max-width: 1350px) {
          .sidebar-layout {
            flex-direction: column;
          }
        }
      `}</style>
    </section>
  );
}

export default SidebarContainer;
